import React from "react";
import { track } from "../../../analytics";
import './LendingAddress.scss'
const LendingAddress = () => {
  return (
    <div className="directumLendingAddress_content">
      <div className="directumLendingAddress_block">
        <div className="directumLendingAddress_item">
          <h2>Хотите стать клиентом Nets?</h2>
          <p>
            <a href="tel:4848" target="_blank" rel="noreferrer" onClick={() => track("phone_click", { number: "4848" })}>
              Закажите обратный звонок
            </a>
          </p>
        </div>
        <div className="directumLendingAddress_item">
          <h2>Есть вопросы по услуге?</h2>
          <p>
            <a href="/directum/#contact">Свяжитесь с нами</a>
          </p>
        </div>
        <div className="directumLendingAddress_item">
          <h2>Адреса офисов:</h2>
          <p>
            <a
              href="https://maps.app.goo.gl/esnpMxxYZLkY4MRw5"
              target="_blank"
              rel="noreferrer"
            >
              Посмотреть на карте
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LendingAddress;
